import api from "./api.js";
import { resolverEstabelecimentoAtivoId } from "../utils/estabelecimentoContext";

export const configuracoes = {
  obter: (estabelecimentoId) =>
    api.get(
      `/configuracoes/estabelecimento/${resolverEstabelecimentoAtivoId(estabelecimentoId)}`
    ),

  atualizar: (estabelecimentoId, dados) =>
    api.put(
      `/configuracoes/estabelecimento/${resolverEstabelecimentoAtivoId(estabelecimentoId)}`,
      dados
    ),

  restaurarPadrao: (estabelecimentoId) =>
    api.post(
      `/configuracoes/estabelecimento/${resolverEstabelecimentoAtivoId(estabelecimentoId)}/restaurar-padrao`
    ),

  obterNotificacoes: (estabelecimentoId) =>
    api.get(
      `/configuracoes/estabelecimento/${resolverEstabelecimentoAtivoId(estabelecimentoId)}/notificacoes`
    ),

  obterHorarios: (estabelecimentoId) =>
    api.get(
      `/configuracoes/estabelecimento/${resolverEstabelecimentoAtivoId(estabelecimentoId)}/horarios`
    ),

  obterAgendamento: (estabelecimentoId) =>
    api.get(
      `/configuracoes/estabelecimento/${resolverEstabelecimentoAtivoId(estabelecimentoId)}/agendamento`
    ),

  buscarClientes: (estabelecimentoId, termo) =>
    api.get(
      `/configuracoes/estabelecimento/${resolverEstabelecimentoAtivoId(estabelecimentoId)}/clientes`,
      { params: { q: termo } }
    ),
};
